import React from 'react'

function CreateRing() {
  return (
    <div>CreateRing</div>
  )
}

export default CreateRing